import gql from 'graphql-tag'

export const ACCOUNT_UPDATE_MUTATION = gql`
    mutation accountUpdate(
        $id: ID!
        $account: AccountInput!
    ) {
        accountUpdate(
            id: $id
            account: $account
        ) {
            id
            type
            status
            number
            name
            description
            balance
            has_postings
            is_assigned
            assignedTo {
                ... on Person {
                    id
                }
                ... on Company {
                    id
                }
                ... on CommissionTypeAccountingConfiguration {
                    id
                }
            }
            assigned_as_type
            created_at
            updated_at
        }
    }
`
